import { useState } from "react";

const FAQS = [
  {
    q: "Do I need any prior tech experience?",
    a: "Nope. Most of our students come in without any tech background. If you're mechanically curious and willing to work with your hands, we'll teach you the rest.",
  },
  {
    q: "How long is the program?",
    a: "Most tracks run 12–16 weeks depending on which specialty you choose. Wire and Computers are shorter tracks; Networks and Fire Alarm are the longer ones.",
  },
  {
    q: "Do I really get to keep the tools and laptop?",
    a: "Yes. As long as you complete the program, your tool kit and laptop are yours. You'll walk out ready to work — literally.",
  },
  {
    q: "What kind of jobs will I qualify for?",
    a: "Low-voltage installer, network support tech, security systems installer, fire alarm technician, field IT tech, and structured cabling tech, to name a few. We work with 120+ hiring partners.",
  },
  {
    q: "Is financial assistance available?",
    a: "We offer payment plans and work with several career-training assistance programs. Call us at 888-866-3428 and admissions will walk you through what fits.",
  },
  {
    q: "When does the next cohort start?",
    a: "New cohorts start every 4–6 weeks. Reach out to admissions and we'll match you with the next best start date for your track.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="relative bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-200 text-secondary-800 text-xs font-mono uppercase tracking-[0.2em] mb-4">
              <i className="ri-question-answer-line"></i> FAQ
            </div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.05]">
              Questions we get a lot.
            </h2>
            <p className="mt-5 text-base text-foreground-700">
              Still curious? Call us at{" "}
              <a
                href="tel:8888663428"
                className="text-primary-600 font-semibold hover:underline cursor-pointer"
              >
                888-866-3428
              </a>{" "}
              — admissions is happy to walk you through anything.
            </p>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`rounded-xl border transition-colors ${
                    isOpen
                      ? "border-primary-400 bg-background-50"
                      : "border-background-200 bg-background-50 hover:border-background-300"
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                    aria-expanded={isOpen}
                  >
                    <span className="font-heading font-semibold text-foreground-950 text-base md:text-lg">
                      {f.q}
                    </span>
                    <span
                      className={`w-9 h-9 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1 text-sm md:text-base text-foreground-700 leading-relaxed">
                      {f.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}